export default __webpack_public_path__ + "static/media/glitch.8041e845.mp4";